import { useDispatch, useSelector } from 'react-redux';
import { handleCurrentStep, selectCurrentStep } from '../DebtAndUpdatePaymentBlockSlice';

export const useBitResultComponent = () => {
  const dispatch = useDispatch();
  const currentStep = useSelector(selectCurrentStep);

  const actions = {
    goToStep: (step) => dispatch(handleCurrentStep(step)),
  };

  return {
    currentStep,
    actions,
  };
};
